import { CHECKOUT_ITEM_TYPE_BOOKING_PROTECTION } from 'constants/checkout'
import uuidV4 from 'lib/string/uuidV4Utils'

export function generateBookingProtectionItem(quote: App.BookingProtectionQuote): App.Checkout.BookingProtectionItem {
  const total = getPriceFromQuote(quote)
  return {
    itemId: uuidV4(),
    transactionKey: uuidV4(),
    itemType: CHECKOUT_ITEM_TYPE_BOOKING_PROTECTION,
    quoteId: quote.quoteId,
    quotedPrice: total,
    total,
  }
}

export function getPriceFromQuote(quote: App.BookingProtectionQuote | undefined): number {
  if (!quote) return 0
  return quote.products.reduce((acc, product) => {
    if (!product.productPrice) return acc
    return acc + product.productPrice
  }, 0)
}
